import { render } from "./vpostgoodslist.vue?vue&type=template&id=26c34662&scoped=true"
import script from "./vpostgoodslist.vue?vue&type=script&lang=js"
export * from "./vpostgoodslist.vue?vue&type=script&lang=js"

import "./vpostgoodslist.vue?vue&type=style&index=0&id=26c34662&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26c34662"]])

export default __exports__